// extracted by mini-css-extract-plugin
export var modalContent = "ConfirmPurchaseModal-module--modalContent--l0Ba-";
export var iconContainer = "ConfirmPurchaseModal-module--iconContainer--OyLoA";
export var purchaseDescription = "ConfirmPurchaseModal-module--purchaseDescription--sgFjg";
export var accept = "ConfirmPurchaseModal-module--accept--YEG1A";